export const SEARCH_FAILED = 'ProvinceTransactionRestriction/search-failed';
export const SEARCH_LOADING = 'ProvinceTransactionRestriction/search-loading';
export const SEARCH_SUCCESS = 'ProvinceTransactionRestriction/search-success';
